import { render, staticRenderFns } from "./ClearscoreLogo.vue?vue&type=template&id=49c12373&scoped=true"
import script from "./ClearscoreLogo.vue?vue&type=script&lang=js"
export * from "./ClearscoreLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c12373",
  null
  
)

export default component.exports